import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { NAMESPACES, SUPPORTED_LANGUAGES } from './namespaces.js'
import { IS_NATIVE_APP } from '../config/appTarget.js'
import { AppStorageKeys, getString, setString } from '../lib/appStorage.js'
import './types.js'

export type { Namespace } from './namespaces.js'

const modules = import.meta.glob<Record<string, unknown>>('./locales/*/*.json', {
  eager: true,
  import: 'default',
})

const resources: Record<string, Record<string, Record<string, unknown>>> = {}
for (const [path, messages] of Object.entries(modules)) {
  const match = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/)
  if (!match) continue
  const [, lng, ns] = match
  resources[lng] ??= {}
  resources[lng][ns] = messages
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'pt',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    ns: [...NAMESPACES],
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    returnObjects: false,
  })

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng.slice(0, 2)
})

// WKWebView/WebView localStorage can be purged by the OS; native keeps the choice in Capacitor Preferences.
async function syncNativeLanguage() {
  const saved = await getString(AppStorageKeys.LANGUAGE)
  if (saved && saved !== i18n.resolvedLanguage) await i18n.changeLanguage(saved)
  i18n.on('languageChanged', (lng) => {
    void setString(AppStorageKeys.LANGUAGE, lng.slice(0, 2))
  })
}

if (IS_NATIVE_APP) void syncNativeLanguage()

export default i18n
